import { z } from 'zod'

// remediation request: re-fetch a filled order's authoritative state from the broker and re-normalize
// its persisted per-share executed price with the lot-size-aware formula. omit tbankOrderId to sweep
// every filled order on the account. dryRun (default true) previews the corrections without writing,
// mirroring the day-trade resync preview/apply flow.
export const orderRenormalizeRequestSchema = z.object({
  tbankOrderId: z.string().optional(),
  dryRun: z.boolean().default(true),
})
export type OrderRenormalizeRequestDto = z.infer<typeof orderRenormalizeRequestSchema>

// one order whose persisted per-share executed price changed under the lot-size-aware normalization
export const orderRenormalizeCorrectionSchema = z.object({
  tbankOrderId: z.string(),
  ticker: z.string().nullable(),
  lotSize: z.number().int(),
  // persisted per-share executed price before vs. after re-normalization
  before: z.number(),
  after: z.number(),
})
export type OrderRenormalizeCorrectionDto = z.infer<typeof orderRenormalizeCorrectionSchema>

// an order that could not be re-normalized (broker no longer returns it, no instrument uid, etc.)
export const orderRenormalizeSkippedSchema = z.object({
  tbankOrderId: z.string(),
  reason: z.string(),
})
export type OrderRenormalizeSkippedDto = z.infer<typeof orderRenormalizeSkippedSchema>

export const orderRenormalizeResultSchema = z.object({
  dryRun: z.boolean(),
  // number of filled orders inspected against the broker
  checked: z.number().int(),
  corrected: z.array(orderRenormalizeCorrectionSchema),
  skipped: z.array(orderRenormalizeSkippedSchema),
})
export type OrderRenormalizeResultDto = z.infer<typeof orderRenormalizeResultSchema>
